"use client";

import React from "react";
import { Cell, Pie, PieChart } from "recharts";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ChartConfig, ChartContainer, ChartLegend, ChartLegendContent, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
const tokenomicsData = [{
  name: "Fund Raising",
  value: 20,
  fill: "var(--color-fund)"
}, {
  name: "Community Rewards & Staking",
  value: 20,
  fill: "var(--color-community)"
}, {
  name: "Reserve & Development",
  value: 20,
  fill: "var(--color-reserve)"
}, {
  name: "Team & Advisors",
  value: 15,
  fill: "var(--color-team)"
}, {
  name: "Partnerships",
  value: 15,
  fill: "var(--color-partnerships)"
}, {
  name: "Liquidity Pool & Stability",
  value: 10,
  fill: "var(--color-liquidity)"
}];
const chartConfig = {
  fund: {
    label: "Fund Raising (20%)",
    color: "var(--chart-1)"
  },
  community: {
    label: "Community Rewards & Staking (20%)",
    color: "var(--chart-2)"
  },
  reserve: {
    label: "Reserve & Development (20%)",
    color: "var(--chart-3)"
  },
  team: {
    label: "Team & Advisors (15%)",
    color: "var(--chart-4)"
  },
  partnerships: {
    label: "Partnerships (15%)",
    color: "var(--chart-5)"
  },
  liquidity: {
    label: "Liquidity Pool & Stability (10%)",
    color: "var(--primary)"
  }
} satisfies ChartConfig;
export default function AizaleaTokenomics() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}